import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import {AppLink} from "@ui-seeker/app";
import {BasicTableSeeker, ButtonIconSeeker, CardSeeker, ImageSeeker} from "@ui-seeker/core"
import {formatDate, formatPrice} from "@ui-seeker/utils";

import {LabelCountry} from "@components";
import {imageModalData} from "@signals";
import {matcherSKUsImageSizeValue} from "../../@signals";
import {SkuAttributesBlock} from "../../@components";
import {useProxiedImage} from "../../../@hooks";


export default function MatcherSkusTargetProduct({ data={}, thumbnail }) {
    const { decodedURL, imageResourceURL } = useProxiedImage(thumbnail)

    return <CardSeeker elevation={3} sx={{ width: 1, height: 0.8, overflowY: 'auto' }}>
        <Grid container spacing={2}>
            <Grid item xs={3} display="flex" justifyContent="center" alignItems="center">
                <ImageSeeker
                    useSpinner
                    lazyLoad={false}
                    src={imageResourceURL}
                    sx={{ border: '1px solid', borderColor: 'divider', width: matcherSKUsImageSizeValue.value, height: 'auto', cursor: 'pointer' }}
                    onClick={() => imageModalData.value = {
                        title: data.productTitle,
                        src: encodeURIComponent(decodedURL)
                    }}
                />
            </Grid>

            <Grid item xs={9} display="flex" flexDirection="column" alignItems="flex-end">
                <Typography color="text.disabled">
                    {data.supertitle}
                </Typography>
                <Typography display="flex" alignItems="center">
                    {data.productTitle}

                    <AppLink to={data.productURL} target="_blank">
                        <ButtonIconSeeker icon="external-link" sx={{ color: 'text.disabled' }} />
                    </AppLink>
                </Typography>
                <Typography color="text.disabled" mb={2}>
                    {data.subtitle}
                </Typography>
                <Typography color="text.disabled">
                    EAN: {data.ean || "-"}
                </Typography>
                <Typography color="text.disabled">
                    Brand: {data.brand || "-"}
                </Typography>
                <Typography color="text.disabled"  mb={2}>
                    Line: {data.line || "-"}
                </Typography>

                <Typography fontSize="0.95rem">
                    <LabelCountry country={data.country} label={data.retailer} />
                </Typography>
                <Typography fontSize="0.95rem">
                    Date: {formatDate(data.date, { isString: true })}
                </Typography>
                <Typography fontSize="0.95rem">
                    Actual Price: {formatPrice(data.actualPrice, data.currency)}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <BasicTableSeeker
                    data={[data]}
                    headers={[[
                        {label: 'Product ID'},
                        {label: 'Variant ID'},
                        {label: 'Reference'}
                    ]]}
                    columns={[
                        { name: 'productID', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'variantRaw', render: value => <Box textAlign="center">{value || "-"}</Box> },
                        { name: 'reference', render: value => <Box textAlign="center">{value || "-"}</Box> }
                    ]}
                    cardProps={{ sx: { boxShadow: 0 } }}
                />
            </Grid>

            <Grid item xs={12} display="flex" flexWrap="wrap" gap={6}>
                <SkuAttributesBlock productID={data.productID} siteID={data.siteID} />
            </Grid>

            <Grid item xs={12}>
                <Typography>
                    {data.description}
                </Typography>
            </Grid>
        </Grid>
    </CardSeeker>
}